import classes from './FormEmployeeNameAndBirth.module.css';

interface Props {
    firstName: string | undefined,
    lastName: string | undefined,
    dateOfBirth: string,
}

const FormEmployeeNameAndBirth = ({ firstName, lastName, dateOfBirth }: Props) => {
    return (
        <div className={classes.applicantName}>
            {`${firstName} ${lastName} (${dateOfBirth})`}
        </div>
    );
}

export default FormEmployeeNameAndBirth;